(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("date-fns"), require("react"), require("react-dom"));
	else if(typeof define === 'function' && define.amd)
		define("formol", ["date-fns", "react", "react-dom"], factory);
	else if(typeof exports === 'object')
		exports["formol"] = factory(require("date-fns"), require("react"), require("react-dom"));
	else
		root["formol"] = factory(root["date-fns"], root["react"], root["react-dom"]);
})(this, (__WEBPACK_EXTERNAL_MODULE__8456__, __WEBPACK_EXTERNAL_MODULE__9155__, __WEBPACK_EXTERNAL_MODULE__9514__) => {
return 